import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivateService} from './activate.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../header/header.service';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {CommonService} from '../../common/common.service';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {Dictionary} from '../../model/dictionary';
import {NotificationsDictionary} from "../../model/notifications-dictionary";
import {UserPrivacyService} from "../user-privacy/user-privacy.service";

@Component({
  selector: 'pbc-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {

  private dictProducts: Array<Dictionary>;
  private dictProductsControls: Array<FormControl>;
  private dictInstitutions: Array<Dictionary>;
  private dictInstitutionsControls: Array<FormControl>;
  private dictClientGroups: Array<Dictionary>;
  private dictClientGroupsControls: Array<FormControl>;
  dictInterestAreas: Array<Dictionary>;
  private dictInterestAreasControls: Array<FormControl>;
  private dictPublicationFrequency : Array<Dictionary>;
  private dictPublicationFrequencyControls : Array<FormControl>;
  private dictNotificationFrequency : Array<NotificationsDictionary>;

  activateForm : FormGroup;
  activationToken: string;
  showConfirmationPopup : boolean = false;
  chosenFrequencyNotification = "";

  constructor(private activateService: ActivateService,
              private commonService : CommonService,
              private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute,
              private headerService: HeaderService,
              private notifierService: NotifierService,
              private userPrivacyService : UserPrivacyService,
              private router: Router) {

    this.headerService.isHomepage(false);
    this.headerService.hideLoginRegisterButtons();

    forkJoin(

      this.commonService.getProductsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getAreaDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getNotificationFrequencyDictionary()

    ).subscribe(([productsResponse, institutionsResponse, clientGroupsResponse, areaResponse, publicationFrequencyResponse, notificationFrequency])=>{

      this.dictProducts = productsResponse;
      this.dictInstitutions = institutionsResponse;
      this.dictClientGroups = clientGroupsResponse;
      this.dictInterestAreas = areaResponse;
      this.dictPublicationFrequency = publicationFrequencyResponse;
      this.dictNotificationFrequency = notificationFrequency;

      this.dictProductsControls = this.dictProducts.map(data => new FormControl(false));
      this.dictInstitutionsControls = this.dictInstitutions.map(data => new FormControl(false));
      this.dictClientGroupsControls = this.dictClientGroups.map(data => new FormControl(false));
      this.dictInterestAreasControls = this.dictInterestAreas.map(data => new FormControl(false));
      this.dictPublicationFrequencyControls = this.dictPublicationFrequency.map(data=> new FormControl(false));

      this.activateForm = this.formBuilder.group({
        products: new FormArray(this.dictProductsControls),
        productsMarkAll : new FormControl(false),
        productsUser: new FormControl(''),
        institutions: new FormArray(this.dictInstitutionsControls),
        institutionsMarkAll : new FormControl(false),
        institutionsUser : new FormControl(''),
        clientGroups: new FormArray(this.dictClientGroupsControls),
        clientGroupsMarkAll : new FormControl(false),
        clientGroupsUser : new FormControl(''),
        interestAreas: new FormArray(this.dictInterestAreasControls),
        interestAreasMarkAll : new FormControl(false),
        interestAreasUser : new FormControl(''),
        publicationFrequency: new FormArray(this.dictPublicationFrequencyControls),
        notificationFrequency: new FormControl(''),
        personalDataProcessingAgreement : new FormControl('', Validators.requiredTrue),
        marketingProcessingAgreement : new FormControl('')
      });
      this.activateForm.setValidators(ActivateComponent.validate);

    },
      (error) => {
      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Pojawił się błąd przy pobieraniu słowników");
      console.log("Błąd przy pobieraniu słowników:", JSON.stringify(error));
    });
  }

  private productMarkAllClick() {
    let markAll : boolean = this.activateForm.controls['productsMarkAll'].value;

    for (let product of this.dictProductsControls)
      product.setValue(!markAll);
  }

  private checkAllProductsSelected() {
    let productsSelected : number = 0;

    for (let product of this.dictProductsControls)
      if (product.value) productsSelected++;

    this.activateForm.controls['productsMarkAll'].setValue(productsSelected === this.dictProducts.length);
  }

  private institutionsMarkAllClick() {
    let markAll : boolean = this.activateForm.controls['institutionsMarkAll'].value;

    for (let institution of this.dictInstitutionsControls)
      institution.setValue(!markAll);
  }

  private checkAllInstitutionsSelected() {
    let institutionsSelected : number = 0;

    for (let institution of this.dictInstitutionsControls)
      if (institution.value) institutionsSelected++;

    this.activateForm.controls['institutionsMarkAll'].setValue(institutionsSelected === this.dictInstitutions.length)
  }

  private clientGroupsMarkAllClick() {
    let markAll : boolean = this.activateForm.controls['clientGroupsMarkAll'].value;

    for (let clientGroup of this.dictClientGroupsControls)
      clientGroup.setValue(!markAll);
  }

  private checkAllClientGroupsSelected() {
    let clientGroupsSelected : number = 0;

    for (let clientGroup of this.dictClientGroupsControls)
      if (clientGroup.value) clientGroupsSelected++;

    this.activateForm.controls['clientGroupsMarkAll'].setValue(clientGroupsSelected === this.dictClientGroups.length);
  }

  private interestAreasMarkAllClick() {
    let markAll : boolean = this.activateForm.controls['interestAreasMarkAll'].value;
    for (let interestArea of this.dictInterestAreasControls)
      interestArea.setValue(!markAll);
  }

  private checkAllInterestAreasSelected() {
    let interestAreasSelected : number = 0;

    for (let interestArea of this.dictInterestAreasControls)
      if (interestArea.value) interestAreasSelected++;

    this.activateForm.controls['interestAreasMarkAll'].setValue(interestAreasSelected === this.dictInterestAreas.length)
  }

  /**
   * Walidator dla całego formularza
   * Formularz uznajemy za poprawmny wttw kiedy mamy zaznaczony przynajmniej jeden chceckbox oraz
   * wskazana jest częstotliwość otrzymywania powiadomień.

   */
  static validate(formControl: AbstractControl) : {[key: string] : boolean} {

    let notificationFrequency : string = formControl.value['notificationFrequency'];
    let personalDataProcessingAgreement : boolean = formControl.value['personalDataProcessingAgreement'];

    if (!personalDataProcessingAgreement || notificationFrequency.length == 0) {
     return {notChecked: true};
    }

    return null;
  }

  savePreferencesClick() {
    let chosenFrequency = this.activateForm.controls['notificationFrequency'].value;

    if (this.areNotificationsDisabled(chosenFrequency))
      this.showConfirmationPopup = true;
    else {
      this.showConfirmationPopup = false;
      this.activateAndSavePreferences();
    }
  };

  private areNotificationsDisabled(id : number) : boolean {
    for (let i = 0; i < this.dictNotificationFrequency.length; i++) {
      if (this.dictNotificationFrequency[i].id == id)
        return this.dictNotificationFrequency[i].disableNotifications;
    }

    return false;
  }

  setSporadicNotificationsClick() {
    let freqId = this.getSporadicNotificationsId();
    this.activateAndSavePreferences(freqId);
    this.showConfirmationPopup = false;
  }

  setNoNotificationsClick() {
    this.activateAndSavePreferences();
    this.showConfirmationPopup = false;
  }

  closeConfirmationPopupClick() {
    this.showConfirmationPopup = false;
  }

  private getSporadicNotificationsId() : number {
    for (let i = 0; i < this.dictNotificationFrequency.length; i++) {
      if (this.dictNotificationFrequency[i].sporadicNotifications)
        return this.dictNotificationFrequency[i].id;
    }
  }

  private activateAndSavePreferences(notificationsFrequencyId? : number) {

    let notificationFrequency;
    if (notificationsFrequencyId)
      notificationFrequency = notificationsFrequencyId;
    else
      notificationFrequency = this.activateForm.controls['notificationFrequency'].value;

    let productsSelected : Array<number> = [];
    let institutionsSelected : Array<number> = [];
    let clientGroupsSelected : Array<number> = [];
    let interestAreasSelected : Array<number> = [];
    let publicationFrequenciesSelected : Array<number> = [];

    let interestProductsUser : string;
    let interestInstitutionsUser : string;
    let interestAreasUser : string;
    let interestClientGroupsUser : string;

    let personalDataProcessingAgreement = this.activateForm.controls['personalDataProcessingAgreement'].value;
    let marketingProcessingAgreement = this.activateForm.controls['marketingProcessingAgreement'].value;

    if (!marketingProcessingAgreement)
      marketingProcessingAgreement = false;

    this.activateForm.value.products.forEach((value:boolean, index : number)=>{
      if (value) productsSelected.push(this.dictProducts[index].id);
    });
    this.activateForm.value.institutions.forEach((value : boolean, index : number) => {
      if (value) institutionsSelected.push(this.dictInstitutions[index].id);
    });
    this.activateForm.value.clientGroups.forEach((value : boolean, index : number) => {
      if (value) clientGroupsSelected.push(this.dictClientGroups[index].id);
    });
    this.activateForm.value.interestAreas.forEach((value : boolean, index : number)=>{
      if (value) interestAreasSelected.push(this.dictInterestAreas[index].id);
    });
    this.activateForm.value.publicationFrequency.forEach((value : boolean, index : number) => {
      if (value) publicationFrequenciesSelected.push(this.dictPublicationFrequency[index].id);
    });

    if (this.activateForm.value.clientGroupsUser && this.activateForm.value.clientGroupsUser.length > 0)
      interestClientGroupsUser = this.activateForm.value.clientGroupsUser;
    if (this.activateForm.value.institutionsUser && this.activateForm.value.institutionsUser.length > 0)
      interestInstitutionsUser = this.activateForm.value.institutionsUser;
    if (this.activateForm.value.interestAreasUser && this.activateForm.value.interestAreasUser.length > 0)
      interestAreasUser = this.activateForm.value.interestAreasUser;
    if (this.activateForm.value.productsUser && this.activateForm.value.productsUser.length > 0)
      interestProductsUser = this.activateForm.value.productsUser;

    this.activateService.activate(this.activationToken).subscribe(
      result => {
        if (result.status === 1) {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, 'Konto zostało aktywowane');
          this.activateService.savePreferences(
            this.activationToken,
            productsSelected,
            institutionsSelected,
            clientGroupsSelected,
            interestAreasSelected,
            interestProductsUser,
            interestInstitutionsUser,
            interestAreasUser,
            interestClientGroupsUser,
            notificationFrequency,
            personalDataProcessingAgreement,
            marketingProcessingAgreement).subscribe(
            result => {
              if (result.status === 1) {
                this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, 'Zapisano preferencje użytkownika');
              }
            },
            error => {
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Wystąpił błąd. Nie zapisano preferencji użytkownika');
              console.log(error);
            }
          )
          this.router.navigate(['login'])
        } else {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, result.message);
        }
      },
      error => {
        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, 'Wystąpił błąd. Konto nie zostało aktywowane');
        console.log(error);
      }
    )
    //
    // forkJoin(
    //   this.activateService.activate(this.activationToken),
    //   this.activateService.savePreferences(
    //     this.activationToken,
    //     productsSelected,
    //     institutionsSelected,
    //     clientGroupsSelected,
    //     interestAreasSelected,
    //     interestProductsUser,
    //     interestInstitutionsUser,
    //     interestAreasUser,
    //     interestClientGroupsUser,
    //     notificationFrequency,
    //     personalDataProcessingAgreement,
    //     marketingProcessingAgreement)
    // ).subscribe(([activateResult, savePreferencesResult])=>{
    //     let userActivated : boolean = false;
    //     if (activateResult.status != 1) {
    //       this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, activateResult.message);
    //       return;
    //     } else
    //       userActivated = true;
    //
    //     if (savePreferencesResult.status != 1)
    //       this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił w trakcie zapisu preferencji: ".concat(savePreferencesResult.message));
    //
    //     if (userActivated) {
    //       this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Konto zostało aktywowane");
    //       this.router.navigate(['login']);
    //     }
    //   }
    // )
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      this.activationToken = params['token'];
    });
  }

  showPrivacyRulesClick() {
    this.userPrivacyService.showPrivacyRulesPopup(true);
  }

  notificationFrequencyChange(tooltip) {
    if (tooltip.isOpen()) {
      tooltip.close();
    }
    let frequencySelected = Number(this.activateForm.controls['notificationFrequency'].value);
    for (let i = 0; i < this.dictNotificationFrequency.length; i++)
      if (this.dictNotificationFrequency[i].id === frequencySelected) {
        this.chosenFrequencyNotification = this.dictNotificationFrequency[i].value_1;
        break;
      }
    let hint = this.chosenFrequencyNotification;
    tooltip.open({hint});
  }

}
